import React, { useMemo } from 'react';
import { Collapse, Empty, Tag, Timeline } from 'antd';
import {
    buildStaffHistoryTimeline, formatStaffHistoryDateTime, getAssignmentEmployeeName,
    getStaffHistoryAction, getStaffHistoryLabels, getStaffHistoryRoleLabel,
} from './customerServiceStaffChangeHelpers';

const { Panel } = Collapse;
function CustomerServiceStaffHistory({ history = [], roles = [], components = [], reasons = [],
    title = 'Lịch sử đã ghi nhận' }) {
    const groups = useMemo(() => buildStaffHistoryTimeline(history), [history]);
    const labels = useMemo(() => getStaffHistoryLabels({ roles, components, reasons }), [roles, components, reasons]);

    const renderChange = row => {
        const action = getStaffHistoryAction(row);
        const fromName = row?.from_assignment ? getAssignmentEmployeeName(row.from_assignment) : 'Chưa phân công';
        const toName = row?.to_assignment ? getAssignmentEmployeeName(row.to_assignment) : 'Không còn phụ trách';
        const adjustments = row.commission_adjustments || [];
        const adjustmentStatuses = Array.from(new Set(adjustments.map(item => item.status)));
        return (
            <div key={row.id} style={{ padding: '10px 12px', border: '1px solid #f0f0f0', borderRadius: 8 }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    <Tag color={action.color} style={{ marginRight: 0 }}>{action.label}</Tag>
                    <strong>{getStaffHistoryRoleLabel(row, labels)}</strong>
                </div>
                <div style={{ fontSize: 15, color: '#262626' }}>
                    <strong>{fromName}</strong><span style={{ color: '#8c8c8c', margin: '0 6px' }}>→</span><strong>{toName}</strong>
                </div>
                {row.reason_code && labels.reason(row.reason_code) !== 'Lý do chưa xác định'
                    ? <div style={{ color: '#595959', marginTop: 6 }}><strong>Lý do:</strong> {labels.reason(row.reason_code)}</div> : null}
                {row.note?.trim() ? <div style={{ color: '#595959', marginTop: 4, whiteSpace: 'pre-wrap' }}><strong>Ghi chú:</strong> {row.note.trim()}</div> : null}
                {row.is_failure ? <Tag color={row.failure_status === 'CONFIRMED' ? 'red' : 'orange'} style={{ marginTop: 8 }}>{labels.failureStatus(row.failure_status)}</Tag> : null}
                {row.is_failure ? <div style={{ color: '#595959', marginTop: 6 }}>
                    <strong>Điều chỉnh hoa hồng:</strong>{' '}
                    {adjustments.length ? `${adjustments.length} yêu cầu — ${adjustmentStatuses.map(status => labels.adjustmentStatus(status)).join(', ')}` : 'Không có khoản hoa hồng thuộc phạm vi cần thu hồi'}
                </div> : null}
            </div>
        );
    };

    return (
        <Collapse bordered={false}
            style={{ marginTop: 16, background: '#fff', borderRadius: 12, overflow: 'hidden' }}>
            <Panel key="staff-history" header={<span style={{ fontWeight: 700 }}>{title} ({groups.length} lần)</span>}>
                {groups.length ? (
                    <Timeline>
                        {groups.map(group => (
                            <Timeline.Item key={group.key} color="blue">
                                <div style={{ marginBottom: 10 }}>
                                    <strong>Hiệu lực: {formatStaffHistoryDateTime(group.effectiveAt)}</strong>
                                    {group.actor?.full_name ? <div style={{ color: '#595959', marginTop: 2 }}>Người thực hiện: {group.actor.full_name}</div> : null}
                                </div>
                                <div style={{ display: 'grid', gap: 8 }}>{group.rows.map(renderChange)}</div>
                            </Timeline.Item>
                        ))}
                    </Timeline>
                ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có lịch sử chuyển giao nhân sự" />}
            </Panel>
        </Collapse>
    );
}

export default CustomerServiceStaffHistory;
